var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfant(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_1019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99771 7.99707H6.00438",
    stroke: "#F6339A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99619 7.99707H10.0028",
    stroke: "#F6339A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66412 10.6626C6.99733 10.8625 7.46382 10.9958 7.99695 10.9958C8.53008 10.9958 8.99657 10.8625 9.32977 10.6626",
    stroke: "#F6339A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6618 4.19843C13.2656 4.95525 13.6772 5.84698 13.8614 6.79744C14.0867 6.90658 14.2768 7.07698 14.4097 7.28913C14.5427 7.50128 14.6132 7.7466 14.6132 7.99698C14.6132 8.24736 14.5427 8.49268 14.4097 8.70483C14.2768 8.91698 14.0867 9.08738 13.8614 9.19652C13.5737 10.5383 12.8345 11.7409 11.7673 12.6036C10.7001 13.4663 9.36926 13.9369 7.99695 13.9369C6.62465 13.9369 5.29384 13.4663 4.2266 12.6036C3.15935 11.7409 2.42022 10.5383 2.13252 9.19652C1.90718 9.08738 1.71714 8.91698 1.58416 8.70483C1.45119 8.49268 1.38066 8.24736 1.38066 7.99698C1.38066 7.7466 1.45119 7.50128 1.58416 7.28913C1.71714 7.07698 1.90718 6.90658 2.13252 6.79744C2.40859 5.44496 3.14273 4.2291 4.21108 3.35499C5.27943 2.48089 6.61658 2.00205 7.99695 1.99927C9.32978 1.99927 10.3294 2.73232 10.3294 3.6653C10.3294 4.59828 9.72962 5.33133 8.99657 5.33133C8.46344 5.33133 7.99695 5.06476 7.99695 4.66492",
    stroke: "#F6339A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_1019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9939,
    height: 15.9939,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfant);
export default __webpack_public_path__ + "static/media/infant.01f32c679e2e05dc05ae18df2615542f.svg";
export { ForwardRef as ReactComponent };